var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionCollapseArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.32919V14.6692C6 17.9892 8.35 19.3392 11.22 17.6892L12.5 16.9492C12.81 16.7692 13 16.4392 13 16.0792V7.91919C13 7.55919 12.81 7.22919 12.5 7.04919L11.22 6.30919C8.35 4.65919 6 6.00919 6 9.32919Z",
    fill: "#50429B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.79152V15.2215C14 15.6115 14.42 15.8515 14.75 15.6515L15.85 15.0115C18.72 13.3615 18.72 10.6415 15.85 8.99152L14.75 8.35152C14.42 8.16152 14 8.40152 14 8.79152Z",
    fill: "#50429B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionCollapseArrowRight);
export default __webpack_public_path__ + "static/media/section-collapse-arrow-right.e6f3c8c9060edfc382962f863b966482.svg";
export { ForwardRef as ReactComponent };